exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5 {\n  color: #000;\n  font-size: 20px;\n  margin-top: -5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/precio-dolar-detail-dialog/precio-dolar-detail-dialog.component.scss
// module id = ../../../../../src/app/components/precios-seccion/financiera/precio-dolar-detail-dialog/precio-dolar-detail-dialog.component.scss
// module chunks = 0